import { Question } from '../../services/chat/getSessions.service';

export const isFeedbackProvided = (historyItem: Question): boolean => {
  if (historyItem.usr_thumbs_up === undefined) {
    return false;
  }

  if (historyItem.ui_show_feedback_form) {
    return false;
  }

  // if (historyItem.usr_thumbs_up) {
  //   if ((historyItem.thumbs_up_feedback?.length ?? 0) !== (historyItem.source_documents?.length ?? 0)) {
  //     return false;
  //   }
  // } else {
  //   if (!historyItem.thumbs_down_feedback) {
  //     return false;
  //   }

  //   if (!historyItem.thumbs_down_feedback.correct_response || !historyItem.thumbs_down_feedback.correct_sources) {
  //     return false;
  //   }
  // }

  return true;
};
